import {
  queryMessages as publicQueryMessages,
  typedQueryMessages as publicTypedQueryMessages,
  askQuestion as publicAskQuestion,
  addFeedback as publicAddFeedback,
  bulkUpdateMessageTags as publicBulkUpdateMessageTags,
  bulkUpdateMessageTagsByFilter as publicBulkUpdateMessageTagsByFilter,
  updateExtendedFields as publicUpdateExtendedFields,
} from './innovation-playground-v2-message-assistant-training.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  MessageQuery,
  MessagesQueryBuilder,
  typedQueryMessages as universalTypedQueryMessages,
} from './innovation-playground-v2-message-assistant-training.universal.js';

function customQueryMessages(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryMessages(httpClient)(),
    typedQueryFunction: (query: MessageQuery) =>
      publicTypedQueryMessages(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): MessagesQueryBuilder;
  function overloadedQuery(
    query: MessageQuery
  ): ReturnType<typeof universalTypedQueryMessages>;
  function overloadedQuery(query?: MessageQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const askQuestion: MaybeContext<
  BuildRESTFunction<typeof publicAskQuestion> & typeof publicAskQuestion
> = /*#__PURE__*/ createRESTModule(publicAskQuestion);
export const addFeedback: MaybeContext<
  BuildRESTFunction<typeof publicAddFeedback> & typeof publicAddFeedback
> = /*#__PURE__*/ createRESTModule(publicAddFeedback);
export const bulkUpdateMessageTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateMessageTags> &
    typeof publicBulkUpdateMessageTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateMessageTags);
export const bulkUpdateMessageTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateMessageTagsByFilter> &
    typeof publicBulkUpdateMessageTagsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateMessageTagsByFilter);
export const updateExtendedFields: MaybeContext<
  BuildRESTFunction<typeof publicUpdateExtendedFields> &
    typeof publicUpdateExtendedFields
> = /*#__PURE__*/ createRESTModule(publicUpdateExtendedFields);
export const queryMessages: MaybeContext<
  BuildRESTFunction<typeof customQueryMessages> & typeof customQueryMessages
> = /*#__PURE__*/ createRESTModule(customQueryMessages);

export {
  Sender,
  Category,
  Action,
  FeedbackType,
  SortOrder,
  WebhookIdentityType,
} from './innovation-playground-v2-message-assistant-training.universal.js';
export {
  Message,
  Feedback,
  Document,
  ReferenceDocument,
  Body,
  ExtendedFields,
  Tags,
  TagList,
  QueryMessagesRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryMessagesResponse,
  CursorPagingMetadata,
  Cursors,
  AskQuestionRequest,
  AskQuestionResponse,
  AddFeedbackRequest,
  AddFeedbackResponse,
  BulkUpdateMessageTagsRequest,
  BulkUpdateMessageTagsResponse,
  ItemMetadata,
  ApplicationError,
  BulkUpdateMessageTagsResult,
  BulkActionMetadata,
  BulkUpdateMessageTagsByFilterRequest,
  BulkUpdateMessageTagsByFilterResponse,
  UpdateExtendedFieldsRequest,
  UpdateExtendedFieldsResponse,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  MessagesQueryResult,
  MessagesQueryBuilder,
  MessageQuerySpec,
  AddFeedbackOptions,
  BulkUpdateMessageTagsOptions,
  BulkUpdateMessageTagsByFilterOptions,
  UpdateExtendedFieldsOptions,
} from './innovation-playground-v2-message-assistant-training.universal.js';
export { utils } from './innovation-playground-v2-message-assistant-training.universal.js';
export {
  SenderWithLiterals,
  CategoryWithLiterals,
  ActionWithLiterals,
  FeedbackTypeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  MessageQuery,
} from './innovation-playground-v2-message-assistant-training.universal.js';
